// extracted by mini-css-extract-plugin
export default {"positionImage":"roulette-wheel_positionImage__jn6V6"};